import { createContext, useContext, useRef, useState } from 'react';

interface IAccountNameContext {
  setAccountName: (name: string) => void;
  accountNameRef: any;
  recallEnsHandler: (value: boolean) => void;
  isRecallEnsHandler: boolean;
  resetAccountName: () => void;
}

const AccountNameContext = createContext<IAccountNameContext>({
  setAccountName: () => {},
  accountNameRef: null,
  recallEnsHandler: () => {},
  isRecallEnsHandler: false,
  resetAccountName: () => {},
});

export const useAccountName = () => {
  return useContext(AccountNameContext);
};

export const AccountNameProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const userId = useRef('');
  const [isRecallEnsHandler, setRecallHandler] = useState(false);

  const setAccountName = (name: string) => {
    userId.current = name;
  };
  const recallEnsHandler = (value: boolean) => {
    setRecallHandler(value);
  };

  const resetAccountName = () => {
    userId.current = '';
  };

  return (
    <AccountNameContext.Provider
      value={{
        setAccountName,
        accountNameRef: userId,
        recallEnsHandler,
        isRecallEnsHandler,
        resetAccountName,
      }}
    >
      {children}
    </AccountNameContext.Provider>
  );
};
